import React from 'react';
import { Check } from 'lucide-react';

const checks = {
  en: [
    'Balanced recipes for sustained energy throughout the day',
    'Anti-inflammatory foods for optimal recovery',
    'Simple 20-minute recipes for a busy lifestyle',
  ],
  de: [
    'Ausgewogene Rezepte für nachhaltige Energie den ganzen Tag',
    'Anti-Entzündungs-Lebensmittel für optimale Erholung',
    'Einfache 20-Minuten-Rezepte für den stressigen Alltag',
  ],
};

export default function NutritionSection({ lang }) {
  const t = {
    label: lang === 'de' ? 'Ernährung' : 'Nutrition',
    headline:
      lang === 'de'
        ? 'ERNÄHRUNG FÜR KÖRPER UND SEELE'
        : 'NUTRITION FOR BODY AND SOUL',
    sub:
      lang === 'de'
        ? 'Iss, was dich glücklich und gesund macht — langfristig und nachhaltig.'
        : 'Eat what makes you happy and healthy — long-term and sustainable.',
    cta: lang === 'de' ? 'JETZT STARTEN' : 'START NOW',
  };

  return (
    <section className="bg-emerald-50/60 py-20 lg:py-28 overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left — text */}
          <div className="flex flex-col gap-6 order-2 lg:order-1">
            <span className="inline-block w-fit px-4 py-1.5 bg-emerald-200 text-emerald-800 text-xs font-bold uppercase tracking-widest rounded-full">
              {t.label}
            </span>

            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-slate-900 tracking-tight leading-tight">
              {t.headline}
            </h2>

            <p className="text-slate-500 text-lg leading-relaxed">{t.sub}</p>

            {/* Checkmarks */}
            <ul className="flex flex-col gap-4 mt-2">
              {checks[lang].map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-7 h-7 rounded-full bg-emerald-600 flex items-center justify-center mt-0.5">
                    <Check size={14} color="white" strokeWidth={3} />
                  </div>
                  <span className="text-slate-700 font-medium leading-snug">{item}</span>
                </li>
              ))}
            </ul>

            <div className="pt-2">
              <a
                href="/s"
                className="inline-flex items-center gap-2 px-7 py-3.5 bg-emerald-600 hover:bg-emerald-700 text-white font-bold rounded-xl shadow-md hover:shadow-lg hover:shadow-emerald-200 transition-all duration-300 hover:-translate-y-0.5"
              >
                {t.cta}
              </a>
            </div>
          </div>

          {/* Right — image */}
          <div className="relative order-1 lg:order-2 flex justify-center">
            <div className="absolute inset-0 -z-10 bg-gradient-to-br from-emerald-200/40 to-lime-200/30 rounded-3xl blur-2xl" />
            <img
              src="https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=800&q=80"
              alt="Healthy food"
              className="w-full max-w-md h-[400px] lg:h-[480px] object-cover rounded-3xl shadow-2xl"
            />
            {/* Floating stat */}
            <div className="absolute -bottom-4 -right-4 lg:right-0 bg-white rounded-2xl px-5 py-3 shadow-xl border border-slate-100">
              <p className="text-xs text-slate-400 font-medium uppercase tracking-wide">
                {lang === 'de' ? 'Rezepte' : 'Recipes'}
              </p>
              <p className="text-2xl font-black text-emerald-600">200+</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
